"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIZE_MAP = exports.COLOR_MAP = void 0;
var design_system_colors_1 = require("../../../style/theme/design-system-colors");
exports.COLOR_MAP = {
    success: {
        backgroundColor: design_system_colors_1.DesignSystemThemeColor.Success.LIGHT_4,
        borderColor: design_system_colors_1.DesignSystemThemeColor.Success.LIGHT_5,
        color: design_system_colors_1.DesignSystemThemeColor.Success.DARK_2,
    },
    warning: {
        backgroundColor: design_system_colors_1.DesignSystemThemeColor.Warning.LIGHT_4,
        borderColor: design_system_colors_1.DesignSystemThemeColor.Warning.LIGHT_5,
        color: design_system_colors_1.DesignSystemThemeColor.Warning.DARK_2,
    },
    error: {
        backgroundColor: design_system_colors_1.DesignSystemThemeColor.Error.LIGHT_4,
        borderColor: design_system_colors_1.DesignSystemThemeColor.Error.LIGHT_5,
        color: design_system_colors_1.DesignSystemThemeColor.Error.DARK_2,
    },
};
exports.SIZE_MAP = {
    sm: { width: 400 },
    md: { width: 600 },
    lg: { width: 800 },
};
